import {
  DIARY_SLOT_ASSIGNEE_SEARCH_REQUEST,
  DIARY_SLOT_ASSIGNEE_SEARCH_SUCCESS,
  DIARY_SLOT_ASSIGNEE_SEARCH_FAIL,
} from "./actionType";

export const searchDiarySlotAssignee = (data) => ({
  type: DIARY_SLOT_ASSIGNEE_SEARCH_REQUEST,
  payload: data,
});

export const searchDiarySlotAssigneeSuccess = (data) => ({
  type: DIARY_SLOT_ASSIGNEE_SEARCH_SUCCESS,
  payload: data,
});

export const searchDiarySlotAssigneeFail = (error) => ({
  type: DIARY_SLOT_ASSIGNEE_SEARCH_FAIL,
  payload: error,
});
